import React, { useState } from 'react';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Button, CircularProgress } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

import axios from '../modules/axios.js';

const useStyles = makeStyles({
  input: {
    display: 'none',
  },
});

export default ({ resource, id, attribute, uploadFile, onUpload, textButton, icon, ...props }) => {
  const classes = useStyles();

  const [isUploading, setIsUploading] = useState(false);

  const upload = async event => {
    setIsUploading(true);
    let res;

    if (uploadFile) {
      res = await uploadFile({ event, attribute, resource, id });
    } else {
      const formData = new FormData();
      formData.append(attribute, event.target.files[0]);

      res = await axios.post(`${resource}/${id}/asset`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    }

    if (onUpload) {
      onUpload(res.data);
    }
    setIsUploading(false);
  };

  return (
    <>
      <input
        className={classes.input}
        id={`contained-button-file-${attribute}`}
        type='file'
        onChange={upload}
        {...props}
      />
      <label htmlFor={`contained-button-file-${attribute}`}>
        <Button
          disabled={isUploading}
          startIcon={icon || <CloudUploadIcon />}
          variant='contained'
          color='primary'
          component='span'
        >
          {isUploading ? <CircularProgress size={24} /> : textButton || 'Charger un fichier'}
        </Button>
      </label>
    </>
  );
};
